<template>
  <div class="whole">
    <div class="show">
      <el-table
          :data="alreadytData.slice((currentPage-1)*pagesize,currentPage*pagesize)"
          :header-cell-style="{'text-align':'center'}"
          :cell-style="{'text-align':'center'}"
          border
          style="width: 100%">
        <el-table-column
            prop="uploadtime"
            :label="$t('label.UploadTime')"
            width="160px">
        </el-table-column>

        <el-table-column
            prop="uploader.username"
            :label="$t('label.UploaderUsername')"
            width="100px">
        </el-table-column>

        <el-table-column
            prop="eva_index.year"
            :label="$t('label.IndexYear')"
            width="100px">
        </el-table-column>

        <el-table-column
            prop="confirmer.username"
            :label="$t('label.ConfirmerUsername')"
            width="100px">
        </el-table-column>

        <el-table-column
            prop="confirmtime"
            :label="$t('label.ConfirmTime')"
            width="100px">
        </el-table-column>

        <el-table-column
            v-if="isOk"
            prop="city.name_cn"
            :label="$t('label.CityName')">
        </el-table-column>

        <el-table-column
            v-if="!isOk"
            prop="city.name_en"
            :label="$t('label.CityName')">
        </el-table-column>

        <el-table-column
            v-if="isOk"
            prop="eva_index.name_cn"
            :label="$t('label.IndexName')"
            width="160px">
        </el-table-column>

        <el-table-column
            v-if="!isOk"
            prop="eva_index.name_en"
            :label="$t('label.IndexName')"
            width="160px">
        </el-table-column>

        <el-table-column
            prop="value"
            :label="$t('label.Value')">
        </el-table-column>

        <el-table-column
            prop="source"
            :label="$t('label.Source')"
            width="150px">
        </el-table-column>

        <template slot="empty">
          <p>{{$t("label.empty")}}</p>
        </template>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
          background
          layout="prev, pager, next"
          :page-size="pagesize"
          @current-change="current_change"
          :total="alreadytData.length">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  name: "test2",
  data(){
    return {
      isOk:'',
      alreadytData: [],
      pagesize:6,//每页的数据条数
      currentPage:1,//默认开始页面
    }
  },
  methods:{
    //监测当前页面
    current_change:function(currentPage){
      this.currentPage = currentPage;
    },
    getAVData(){
      var that=this
      request.get('/confirm/search?state=1').then(function (res){
        that.alreadytData=res.data
      }).catch(function (err){
        console.log(err)
      })
    }
  },
  mounted() {
    this.getAVData()
  },
  created() {
    if(this.$i18n.locale==='cn'){
      this.isOk=true
    }
    else{
      this.isOk=false
    }
  }
}
</script>

<style scoped>
@import "~@/assets/css/sameCss.css";
.show{
  margin-top: 20px;
  text-align: center;
}
</style>